module.exports = __webpack_public_path__ + "img/sxcl_top.cbd07ce7.png";